import { useStripe, useElements, PaymentElement } from '@stripe/react-stripe-js';
import { Button } from "./Controls/Button";
import { connectUrl } from "./Data/WebUrl";
import { useParamIds } from './Data/Common';
import { useNavigate } from "react-router-dom";
import { PageMaskOpts, maskAtom  } from './Data/Atoms';
import { useAtom                 } from 'jotai';     

export function StripeAddPaymentMethodForm() {
    const stripe   = useStripe();
    const elements = useElements();
    const { planId }      = useParamIds();
    const nav = useNavigate();
    const maskOptions: PageMaskOpts = {
        showMask: true,
        header:  <div className="h2">Processing</div>,
        subText: 'Do not close your browser',
    };

    const [, setShowMask] = useAtom( maskAtom );


    const handleSubmit = async ( event: any ) => {
        event.preventDefault();

        if( !stripe || !elements ) {
            return;
        }

        setShowMask(maskOptions);

        const result = await stripe.confirmSetup( {
            elements,
            confirmParams: {
            return_url: connectUrl(
            `/user/billing/add/success?` +
            `returnTo=${encodeURIComponent(`/user/plan/${planId}`)}` +
            `&returnLabel=${encodeURIComponent('Back To Plan')}`
            )
            },
        } );

        // TODO: add audit entry

        if( result.error ) {
            // Show error to your customer (for example, payment details incomplete)
            console.log( result.error.message );
        } else {
            // Your customer will be redirected to your `return_url`. For some payment
            // methods like iDEAL, your customer will be redirected to an intermediate
            // site first to authorize the payment, then redirected to the `return_url`.
        }

         setShowMask(undefined);
    };

    return <form onSubmit={handleSubmit}>      
        <PaymentElement />
        <div className="d-flex justify-content-end">
            <Button  type="button" className="mt-2 px-3 mx-2"  onClick={() => { nav(-1) }}>
                Cancel
            </Button>
            <Button type="submit" disabled={!stripe} className="mt-2 px-3 btn-main">
                Update Payment Method
            </Button>
        </div>
    </form>;
};

